// eslint-disable-next-line max-len
var USER_INTERFACE_CROSS_CANCEL = 'M31.63,29.87a1.24,1.24,0,0,1-1.76,1.76L16,17.77,2.13,31.63A1.24,1.24,0,0,1,.37,29.87L14.23,16,.37,2.13A1.24,1.24,0,0,1,2.13.37L16,14.23,29.87.37a1.24,1.24,0,0,1,1.76,1.76L17.77,16Z';

export { USER_INTERFACE_CROSS_CANCEL };
//# sourceMappingURL=USER_INTERFACE_CROSS_CANCEL.js.map
